import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import { Popover } from '@mui/material';
import { useId, useState } from 'react';
import { VARIABLE_NAME_TO_COLUMN } from '../constantsArticleExcel';

const IssuesPopover = ({ issues, excelRow, excelSheet }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const id = useId();

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  if (!issues || !issues?.length || issues?.length === 0) return null;

  return (
    <>
      <span
        aria-owns={open ? `mouse-over-popover-${id}` : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        <ReportProblemOutlinedIcon
          style={{
            color: '#c50202',
            width: '1rem',
            height: '1rem',
          }}
        />
      </span>
      <Popover
        id={`mouse-over-popover-${id}`}
        sx={{ pointerEvents: 'none' }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <div className="diff-popover-container">
          <p>Problemas</p>
          {excelSheet && excelRow && (
            <p style={{ fontSize: '0.75rem', color: '#888', margin: '0 0 0.4rem 0' }}>
              Pestaña: <strong>{excelSheet}</strong> · Fila: <strong>{excelRow}</strong>
            </p>
          )}
          <div>
            {issues.map((issue, idx) => (
              <p key={idx}>
                {issue?.field && (
                  <strong style={{ marginRight: '0.3rem', color: '#c50202' }}>
                    [{VARIABLE_NAME_TO_COLUMN[issue.field] ?? issue.field}]
                  </strong>
                )}
                {issue?.message ?? issue}
              </p>
            ))}
          </div>
        </div>
      </Popover>
    </>
  );
};

export default IssuesPopover;
